import type {
  ICheckboxDropdownMenuItem,
  IDefaultDropdownMenuItem,
  IDropdownMenuItem,
  IDropdownMenuItemInternalProps
} from '../../../types/Dropdown/dropdown_menu_item/dropdownMenuItem';
import { DropdownCheckMarkIcon } from '../../../assets/Icons';
import { Checkbox } from '../../Checkbox';
import styles from './dropdown-menu-item.module.scss';

export const DropdownMenuItem = (props: IDropdownMenuItem) => {

  const {
    type = 'default',
    text,
    count,
    hintText,
    disabled = false,
    closeOnItemClick = true,
    render,
    ...internalProps
  } = props as IDropdownMenuItem;

  const {
    icon,
    selected,
    hideCheckMarks = false,
    onClickHandler,
    iconType = 'default',
    iconColor = 'default',
    additionalData
  } = props as IDefaultDropdownMenuItem;
  const { id, checked, checkboxIcon, onChangeHandler, onCheckboxItemClickHandler } = props as ICheckboxDropdownMenuItem;
  const { closeDropdown } = (internalProps as IDropdownMenuItemInternalProps);

  const handleClick = (text: string, additionalData?: any) => {
    onClickHandler?.(text, additionalData);
    closeOnItemClick && closeDropdown?.();
  };

  const menuItemCount = (typeof count === 'number') ?
    <span data-dropdown-menu-item-count>
      {`(${count})`}
    </span> : <></>;

  return (
    <div
      className={styles['dropdown-menu-item']}
      data-dropdown-menu-item-disabled={disabled}
      data-dropdown-menu-item-selected={selected}
      onClick={() => handleClick(text || hintText || '', additionalData)}
    >
      {
        type === 'default' && icon &&
        <div
          className={styles['dropdown-menu-item__featured-icon']}
          data-dropdown-menu-item-icon-type={iconType}
          data-dropdown-menu-item-icon-color={iconColor}
        >
          {icon}
        </div>
      }

      {
        type === 'checkbox' &&
        <div className={styles['dropdown-menu-item__checkbox']}>
          <Checkbox
            id={id}
            size='md'
            checkboxIcon={checkboxIcon}
            text={<>{text} {menuItemCount}</> as any}
            hintText={hintText}
            disabled={disabled}
            checked={checked}
            onChangeHandler={onChangeHandler}
            onClickHandler={onCheckboxItemClickHandler}
            render={render}
          />
        </div>
      }

      {
        type === 'default' &&
        (!!render ? render : (text || hintText) &&
          <div className={styles['dropdown-menu-item__text-box']}>
            {
              text &&
              <div className={styles['dropdown-menu-item__text-box__text']} title={typeof text === "string" ? text : ""}>
                {text} {menuItemCount}
              </div>
            }
            {hintText && <div className={styles['dropdown-menu-item__text-box__hint-text']} title={hintText}>{hintText}</div>}
          </div>
        )
      }

      {
        type === 'default' && selected && !hideCheckMarks &&
        <div className={styles['dropdown-menu-item__tick-icon']}>{DropdownCheckMarkIcon}</div>
      }
    </div>
  )
}
